<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="headline">{{ dog.callName }}</span>
        <v-switch
            v-model="expanded"
            class="ma-1"
            label="Details"
        ></v-switch>
      </v-card-title>

      <v-card-text v-show="expanded">
        <v-container>
          <dog-edit :dog="currentDog" :mbr="member" v-show="!editInProcess" @endDogEdit="endDogEdit" @dogAdded="dogAdded"></dog-edit>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>

</template>

<script>
import DogEdit from "@/components/DogEdit";

export default {
  name: "DogDetail",
  components: {
    DogEdit,
  },
  props: {
    dog: {
      type: Object,
      default: null
    },
    mbr: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    regs: {
      type: Object,
      default: null
    },
  },
  computed: {
    currentDog() {
      return this.dog
    },
    member() {
      return this.mbr
    }
  },
  methods: {
    endDogEdit: function (item) {
      this.editInProcess = false
      this.expanded = false

      if(item) {
        console.log(item)
        // this.dogs.splice(this.editedIndex,1,item)
      }

    },
    dogAdded: function(item) {
      this.$emit('dogAdded', item)
    }
},
  data: () => ({
    expanded: false,
    editInProcess: false
  })
}
</script>

<style scoped>
.compact {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
